export default __webpack_public_path__ + "static/media/logo_cliente.b50ba653.png";